import { createBrowserRouter, redirect } from "react-router-dom";
import AuthLayout from "./layouts/AuthLayout";
import RootLayout from "./layouts/RootLayout";
import CrifBureauSearchPage from "./pages/CrifBureauSearchPage";
import DashboardPage from "./pages/DashboardPage";
import DevModulePage from "./pages/DevModulePage";
import EligibilityCheckPage from "./pages/EligibilityCheckPage";
import InboundCallEntryPage from "./pages/InboundCallEntryPage";
import LiveDashboardPage from "./pages/LiveDashboardPage";
import LoginPage from "./pages/LoginPage";
import DailyCallAssignmentPage from "./pages/DailyCallAssignmentPage";
import NotFoundPage from "./pages/NotFoundPage";
import PilInfoPage from "./pages/PilInfoPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import TelecallingRecordsPage from "./pages/TelecallingRecordsPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import UserManagementPage from "./pages/UserManagementPage";
import WelcomeLetterPage from "./pages/WelcomeLetterPage";
import SarvamVoiceAutomationPage from "./features/sarvamVoiceAutomation/SarvamVoiceAutomationPage";
import { getSavedAuthSession, getSavedAuthState } from "./utils/authStorage";

function redirectAuthenticatedUser() {
  if (getSavedAuthState()) {
    return redirect("/dashboard");
  }

  return null;
}

function requireAuth() {
  if (!getSavedAuthState()) {
    return redirect("/");
  }

  return null;
}

function requireModule(moduleKey) {
  const authRedirect = requireAuth();

  if (authRedirect) {
    return authRedirect;
  }

  const session = getSavedAuthSession();

  if (!session?.moduleAccess?.[moduleKey]) {
    return redirect(`/unauthorized?module=${moduleKey}`);
  }

  return null;
}

export const routes = [
  {
    path: "/",
    element: <AuthLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        loader: redirectAuthenticatedUser,
        element: <LoginPage />,
      },
      {
        path: "reset-password",
        element: <ResetPasswordPage />,
      },
      {
        path: "dashboard",
        loader: requireAuth,
        element: <RootLayout />,
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
        ],
      },
      {
        path: "dev-module",
        loader: requireAuth,
        element: <RootLayout />,
        children: [
          {
            index: true,
            element: <DevModulePage />,
          },
          {
            path: "sarvam",
            element: <SarvamVoiceAutomationPage />,
          },
        ],
      },
      {
        path: "live-dashboard",
        loader: () => requireModule("liveDashboard"),
        element: <LiveDashboardPage />,
      },
      {
        path: "reports/live-dashboard",
        loader: () => {
          const authRedirect = requireAuth();

          return authRedirect || redirect("/live-dashboard");
        },
      },
      {
        path: "telecalling/daily-assignment",
        loader: () => requireModule("dailyCallAssignment"),
        element: <DailyCallAssignmentPage />,
      },
      {
        path: "pilinfo",
        loader: () => requireModule("customerInfoSearch"),
        element: <PilInfoPage />,
      },
      {
        path: "inbound",
        loader: () => requireModule("inboundCallEntry"),
        element: <InboundCallEntryPage />,
      },
      {
        path: "telecalling-records",
        loader: () => requireModule("telecallingRecords"),
        element: <TelecallingRecordsPage />,
      },
      {
        path: "eligibility-check",
        loader: () => requireModule("eligibilityCheck"),
        element: <EligibilityCheckPage />,
      },
      {
        path: "welcome-letter",
        loader: () => requireModule("welcomeLetter"),
        element: <WelcomeLetterPage />,
      },
      {
        path: "crif",
        loader: () => requireModule("crifBureauSearch"),
        element: <CrifBureauSearchPage />,
      },
      {
        path: "user-management",
        loader: () => requireModule("userManagement"),
        element: <UserManagementPage />,
      },
      {
        path: "unauthorized",
        loader: requireAuth,
        element: <UnauthorizedPage />,
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export default router;
